module.exports = __webpack_public_path__ + "static/img/common.28504f1.png";


//////////////////
// WEBPACK FOOTER
// ./static/hk/mobile_img/common.png
// module id = 722s
// module chunks = 7